import React, { type ReactElement } from 'react';

const EmptyEmailIcon = (): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="137"
    height="107"
    viewBox="0 0 137 107"
  >
    <title>Empty email icon</title>
    <defs>
      <path
        id="a"
        d="M27.585 0C12.414 0 0 13.02 0 28.932v42.191C0 80.405 7.242 88 16.092 88H105.737c8.85 0 16.091-7.595 16.091-16.877V28.932C121.828 13.019 109.416 0 94.244 0h-66.66z"
      />
    </defs>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-1211 -1919) translate(1212 1920) translate(6.547 18)">
        <mask fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <use fill="#FFE3F4" xlinkHref="#a" />
      </g>
      <g
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        transform="translate(-1211 -1919) translate(1212 1920)"
      >
        <path
          stroke="#031D44"
          d="M68.509 78c.356 0-18.526-6.796-56.645-20.387C5.339 55.296 0 47.935 0 41.257V12.141C0 5.463 5.693 0 12.65 0H93"
        />
        <path
          stroke="#031D44"
          d="M135 78L80.812 57.613C74.315 55.296 69 47.935 69 41.257V12.141C69 5.463 74.668 0 81.596 0h29.019"
          transform="matrix(-1 0 0 1 204 0)"
        />
        <path stroke="#FFF" d="M8 104.779L39.922 75" />
        <path stroke="#FFF" d="M98 75L129.923 104.779" />
      </g>
    </g>
  </svg>
);

export default EmptyEmailIcon;
